import WebFormDestination from '@/shared/enums/webFormDestination'

export default {
  name: 'NewWebForm',

  props: {
    placeholder: String,
    title: String,
    data: Object,
    isNew: Boolean
  },

  data: () => ({
    toDestinations: Object.values(WebFormDestination)
  }),
  
  computed: {
    state() {
      if (this.data && this.data.name) {
        return this.data.name.length >= 4
      }
    },
    
    disable() {
      if (this.isNew === true) {
        if (this.data && this.data.name && this.data.destination != null) {
          return this.data.name.length < 4
        }
      } else {
          if (this.data && this.data.name && this.data.destination != null) {
            return this.data.name.length < 4
        }
      }
      return true
    }
  },

  methods: {
    backTo() {
      this.$router.go(-1)
    },

    save() {
      this.isNew 
        ? this.$emit('create', this.data)
        : this.$emit('update', this.data)
    }
  }
}
